import { Button, Select } from '@sharedComponents/DesignSystem/Inputs';
import { submissionsTypes } from '@constants/submissionsTypes';
import React, { useEffect, useState } from 'react';
import { SubmissionQueryInterface } from '@types';
import { CompaniesEnum, LangEnum, SubmissionTypes } from '@enums';
import { Checkbox } from '@sharedComponents/Checkbox';
import ventionLogo from '@images/logoVention-black.png';
import itechartLogo from '@images/logo-black.png';
import { translate } from 'utils/translate';
import { langOptions } from '@constants/langOptions';
import './index.scss';

interface ILettersFilterPopoverProps {
  submissionType?: SubmissionTypes;
  handleFilterChange?: (value: Partial<SubmissionQueryInterface>) => void;
  filterCompanies: CompaniesEnum[];
  filterLanguage?: LangEnum;
  canViewPrivateTemplate?: boolean;
}

export const FilterPopover = ({
  submissionType,
  handleFilterChange,
  filterCompanies,
  filterLanguage,
  canViewPrivateTemplate = false,
}: ILettersFilterPopoverProps) => {
  const [submissionTypeControl, setSubmissionTypeControl] = useState<SubmissionTypes>(
    submissionType || null
  );

  const [partialFilters, setPartialFilters] = useState<Partial<SubmissionQueryInterface>>(null);
  const [companies, setCompanies] = useState<CompaniesEnum[]>(filterCompanies);
  const [language, setLanguage] = useState<LangEnum>(filterLanguage);

  const handleSelect = (value) => {
    setSubmissionTypeControl(value);
  };

  const submissionOptions = submissionsTypes.filter((option) =>
    canViewPrivateTemplate ? option : option.value !== SubmissionTypes.Private
  );

  const handleCompanyCheckbox = (company: CompaniesEnum) => {
    let currentCompanies = [...companies];
    if (currentCompanies.includes(company)) {
      currentCompanies = currentCompanies.filter((value) => value !== company);
    } else {
      currentCompanies.push(company);
    }
    setCompanies(currentCompanies);
  };

  const handleLanguageMenu = (language: LangEnum) => {
    setLanguage(language);
  };

  useEffect(() => {
    setPartialFilters(
      submissionTypeControl
        ? {
            submissionType: submissionTypeControl,
            company: companies,
            lang: language,
          }
        : {
            company: companies,
            lang: language,
          }
    );
  }, [submissionTypeControl, companies, language]);

  return (
    <>
      <div className="filter-popover-container">
        <div className="filter-controls-container">
          {Object.keys(CompaniesEnum).map((company) => {
            return (
              <div
                key={CompaniesEnum[company]}
                className="filter-popover-company"
                data-testid={`filter-checkbox-${CompaniesEnum[company]}`}
              >
                <Checkbox
                  checked={companies.includes(CompaniesEnum[company])}
                  onChange={() => handleCompanyCheckbox(CompaniesEnum[company])}
                />
                <img
                  className="logo-black"
                  src={
                    CompaniesEnum[company] === CompaniesEnum.Itechart ? itechartLogo : ventionLogo
                  }
                  alt={'logo-' + CompaniesEnum[company]}
                />
              </div>
            );
          })}
          <div data-testid="filter-submission-type-select">
            {submissionTypeControl && (
              <Select
                options={submissionOptions}
                value={submissionTypeControl}
                handleChange={handleSelect}
                className="filter-select"
                testId="select-template-type"
              />
            )}
          </div>
          <div data-testid="filter-submission-lang-select">
            {language && (
              <Select
                options={langOptions}
                value={language}
                handleChange={handleLanguageMenu}
                className="filter-select"
                testId="select-language"
              />
            )}
          </div>
        </div>
        <div className="filter-button-container" data-testid="filter-submit-button">
          <Button type="stroke" onClick={() => handleFilterChange(partialFilters)}>
            {translate('apply').toUpperCase()}
          </Button>
        </div>
      </div>
    </>
  );
};
